module.exports = __webpack_public_path__ + "img/uob-img.f57d2b2a.png";